// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"481":"96730c30","787":"d654f185"}[chunkId] + ".chunk.js";
};